// src/disc/DiscLayout.js
import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Dashboard as DashboardIcon,
  Compare as CompareIcon,
  Autorenew as AutorenewIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import DiscConfiguration from './DiscConfiguration';
import DiscDashboard from './DiscDashboard';
import DiscComparison from './DiscComparison';
import DiscReanalyze from './DiscReanalyze';

const DiscLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
          {t('disc.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('disc.subTitle')}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="disc tabs">
          <Tab
            icon={<AssignmentIcon />}
            label={t('disc.configuration')}
            id="disc-tab-0"
            aria-controls="disc-tabpanel-0"
          />
          <Tab
            icon={<CompareIcon />}
            label={t('disc.comparisons')}
            id="disc-tab-1"
            aria-controls="disc-tabpanel-1"
          />
          <Tab
            icon={<AutorenewIcon />}
            label={t('disc.reanalyze')}
            id="disc-tab-2"
            aria-controls="disc-tabpanel-2"
          />
          <Tab
            icon={<DashboardIcon />}
            label={t('disc.dashboard')}
            id="disc-tab-3"
            aria-controls="disc-tabpanel-3"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <DiscConfiguration />}
        {tabValue === 1 && <DiscComparison />}
        {tabValue === 2 && <DiscReanalyze />}
        {tabValue === 3 && <DiscDashboard />}
      </Box>
    </Box>
  );
};

export default DiscLayout;